import { ArrowDownTrayIcon, DocumentArrowDownIcon, EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { ActionIcon, Button, Group, Menu } from "@mantine/core";
import React from "react";

export interface ReportActionsToolbarProps {
  /** Optional so a future report type can omit it; the button renders disabled rather than wired to a 404. */
  onExportExcel?: () => void;
  /** Optional so a future report type can omit it; the button renders disabled rather than wired to a 404. */
  onExportCsv?: () => void;
  onExportCvForSelected: () => void;
  onExportCvForAll: () => void;
  selectedCount: number;
  totalCount: number;
  exporting?: boolean;
}

/**
 * Export to Excel / CSV (full matching set, not just the current page — see FS_05_Reporting_01),
 * "Export CV for all matching" (no selection needed), and "Export CV for selected" for a narrower
 * pick. The overflow menu is a deliberate empty extension point for future actions ("any other
 * operations in future") — not built out speculatively.
 */
export const ReportActionsToolbar: React.FC<ReportActionsToolbarProps> = ({
  onExportExcel,
  onExportCsv,
  onExportCvForSelected,
  onExportCvForAll,
  selectedCount,
  totalCount,
  exporting = false,
}) => {
  return (
    <Group gap="xs" wrap="wrap">
      <Button
        variant="light"
        color="brand"
        size="xs"
        leftSection={<DocumentArrowDownIcon width={16} />}
        onClick={onExportExcel}
        loading={exporting}
        disabled={!onExportExcel}
        title={!onExportExcel ? "Coming soon" : undefined}
      >
        Export to Excel
      </Button>
      <Button
        variant="light"
        color="brand"
        size="xs"
        leftSection={<DocumentArrowDownIcon width={16} />}
        onClick={onExportCsv}
        loading={exporting}
        disabled={!onExportCsv}
        title={!onExportCsv ? "Coming soon" : undefined}
      >
        Export to CSV
      </Button>
      <Button
        variant="light"
        color="brand"
        size="xs"
        leftSection={<ArrowDownTrayIcon width={16} />}
        onClick={onExportCvForAll}
        disabled={totalCount === 0}
        loading={exporting}
      >
        Export CV for all ({totalCount})
      </Button>
      <Button
        variant="light"
        color="brand"
        size="xs"
        leftSection={<ArrowDownTrayIcon width={16} />}
        onClick={onExportCvForSelected}
        disabled={selectedCount === 0}
        loading={exporting}
      >
        Export CV for selected ({selectedCount})
      </Button>
      <Menu shadow="md" position="bottom-end">
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray" size="lg" aria-label="More actions">
            <EllipsisHorizontalIcon width={20} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>More actions coming soon</Menu.Label>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
